import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20deep%20emerald%20and%20charcoal%20geometric%20background%20with%20a%20glowing%20translucent%20shield%20made%20of%20thin%20light%20lines%2C%20encrypted%20data%20mesh%20pattern%20fading%20into%20soft%20fog%2C%20subtle%20amber%20signal%20accents%2C%20cinematic%20depth%20of%20field%2C%20minimal%20modern%20security%20editorial%20aesthetic%2C%20high%20contrast%20dark%20scene&width=1600&height=900&seq=baoliao51-hero-01&orientation=landscape"
          alt="爆料51匿名通道的加密信息与隐私保护视觉背景"
          title="爆料51匿名通道 隐私保护 保密机制"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/85 via-primary-950/70 to-primary-950/90"></div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="max-w-3xl">
          <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs bg-background-50/10 border border-background-50/20 text-background-100 backdrop-blur mb-6 animate-fade-in">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse-soft"></span>
            匿名投稿 · 隐私保护 · 保密机制
          </p>

          <h1 className="font-heading font-bold text-4xl md:text-6xl leading-tight text-background-50 animate-fade-up">
            爆料51匿名通道
            <span className="block mt-3 text-accent-300">让安全爆料不必露面</span>
          </h1>

          <p className="mt-6 text-base md:text-lg leading-relaxed text-background-200 max-w-2xl animate-fade-up">
            担心爆料暴露身份？{""}
            <strong className="font-semibold text-background-50">爆料51</strong>采用隐私保护与保密机制处理每一条信息。
            无需注册、不强制实名，你可以只留下事实本身，安心说出你知道的。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 animate-fade-up">
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-medium whitespace-nowrap bg-accent-500 text-primary-950 hover:bg-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-lock-2-line" aria-hidden="true"></i>
              立即匿名投稿
            </Link>
            <a
              href="#process"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-medium whitespace-nowrap border border-background-50/30 text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              <i className="ri-flow-chart" aria-hidden="true"></i>
              了解保密机制
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl">
            <div className="flex items-center gap-3">
              <i className="ri-user-forbid-line text-accent-300 text-xl" aria-hidden="true"></i>
              <dt className="text-sm text-background-200">无需注册账号</dt>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-id-card-line text-accent-300 text-xl" aria-hidden="true"></i>
              <dt className="text-sm text-background-200">不强制实名</dt>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-time-line text-accent-300 text-xl" aria-hidden="true"></i>
              <dt className="text-sm text-background-200">约 3 个工作日反馈</dt>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}